import { getPostHogClient } from "./client";
import type { PostHogFixedProperties } from "./catalog";

export type AnalyticsSuperProperties = Partial<PostHogFixedProperties>;

export function registerAnalyticsSuperProperties(
  properties: AnalyticsSuperProperties
): void {
  const client = getPostHogClient();
  if (!client) return;

  const next: Record<string, string> = {};
  const unset: string[] = [];

  for (const [key, value] of Object.entries(properties)) {
    if (value == null || value === "") {
      unset.push(key);
    } else {
      next[key] = String(value);
    }
  }

  if (Object.keys(next).length > 0) {
    client.register(next);
  }
  for (const key of unset) {
    client.unregister(key);
  }
}

/** PostHog screen insights break down on `$screen_name`. */
export function registerAnalyticsScreenName(screenName: string | undefined): void {
  const client = getPostHogClient();
  if (!client) return;
  if (!screenName) {
    client.unregister("$screen_name");
    return;
  }
  client.register({ $screen_name: screenName });
}
